export { default } from './capitalize';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/capitalize/index.js
// module id = 164
// module chunks = 25